module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <a href="'+
((__t=( url ))==null?'':__t)+
'" target="_blank"><b><h4>'+
((__t=( headline ))==null?'':__t)+
'</h4></b></a>\n  '+
((__t=( summary ))==null?'':__t)+
'\n';
}
return __p;
};
